import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/open/page';

// `$id_` keeps this out of the app's settings layout: the app fills the whole
// content area, with no header above it (KAN-1081).
export const Route = createFileRoute('/_app/_chat/apps/$id_/open')({
  component: Page,
});
